import React, { useState } from "react";
import { Flex, H1, H2, Text } from "ui-components";
import FormattedMessage from "components/FormattedMessage";
import { MinusCircleOutline, PlusCircleOutline } from "components/Icons";
import { COLORS } from "ui-components/theme";
import get from "lodash/get";

const SIMCountSelector = ({
  title,
  subtitle,
  main_title,
  minNumber,
  disabled,
  maxNumber,
  handleChange,
  fieldName,
  simCount,
  themeColors,
  data
}) => {
  const [plusHovered, setPlusHovered] = useState(false);
  const [minusHovered, setMinusHovered] = useState(false);
  const isDisabled = disabled || data?.disabled;
  const plusDisabled = simCount >= maxNumber || isDisabled;
  const minusDisabled = simCount <= minNumber || isDisabled;
  const plusColor = get(
    themeColors?.cta,
    plusHovered && !plusDisabled ? "hoverColor" : "color",
    COLORS.blue[4]
  );
  const minusColor = get(
    themeColors?.cta,
    minusHovered && !minusDisabled ? "hoverColor" : "color",
    COLORS.blue[4]
  );

  // Increment for Decrement the SIM count based on the type.
  const handleSIMCountChange = type => {
    const count = type === "inc" ? simCount + 1 : simCount - 1;

    handleChange(fieldName, count);
  };

  return (
    <>
      {main_title && (
        <H2>
          <FormattedMessage id={main_title}></FormattedMessage>
        </H2>
      )}
      <Flex
        justifyContent={"center"}
        alignItems={"center"}
        flexDirection={"column"}
        pt={3}
        pb={4}
        width={"100%"}
        maxWidth={"680px"}
        margin={"15px auto"}
      >
        <Flex justifyContent={"center"} alignItems={"center"} width={"100%"}>
          <button
            onClick={() => !minusDisabled && handleSIMCountChange("dec")}
            type="button"
            disabled={minusDisabled}
            onMouseOver={() => setMinusHovered(true)}
            onMouseOut={() => setMinusHovered(false)}
          >
            <MinusCircleOutline size="36px" color={minusColor} />
          </button>

          <H1 display="flex" marginX="10px" fontSize="34px">
            {simCount}
            <FormattedMessage id={title}>
              {msg => <Text marginLeft="5px">{msg}</Text>}
            </FormattedMessage>
          </H1>

          <button
            type="button"
            onClick={() => !plusDisabled && handleSIMCountChange("inc")}
            disabled={plusDisabled}
            onMouseOver={() => setPlusHovered(true)}
            onMouseOut={() => setPlusHovered(false)}
          >
            <PlusCircleOutline size="36px" color={plusColor} />
          </button>
        </Flex>

        <Flex justifyContent={"center"} alignItems={"center"} width={"100%"}>
          <FormattedMessage id={subtitle} values={{ maxNumber }}>
            {msg => (
              <Text
                color={COLORS.gray[1]}
                marginTop="5px"
                opacity="0.6"
                fontSize="14px"
              >
                {msg}
              </Text>
            )}
          </FormattedMessage>
        </Flex>
      </Flex>
    </>
  );
};

SIMCountSelector.defaultProps = {
  minNumber: 1,
  maxNumber: 6,
  title: "sim_count_text_1",
  subtitle: "sim_count_text_2",
  fieldName: "sim_count"
};

export default SIMCountSelector;
